import { render, staticRenderFns } from "./TituloInstituicaoEnsino.vue?vue&type=template&id=3dbf352f&"
import script from "./TituloInstituicaoEnsino.vue?vue&type=script&lang=js&"
export * from "./TituloInstituicaoEnsino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports